export abstract class ContainerItemAware{

    _id: string;
}